



    import {
        ChangeEventsModule,
        DisplayModule,
        DocumentsModule,
        RouterModule,
        UsersModule,
    } from '@/store/store.helper';
import { NavBarInterface, NAVBAR_SIDE_ICON } from '@/store/types';
import firebase from 'firebase/app';
import {Component, Vue, Watch} from 'vue-property-decorator';
    import {EVENT_TYPE, ROUTE_NAME} from '@/types/enums';
import Login from '@/views/Login/Login';
import { eventBus } from "@/main";
import * as enums from "@/types/enums";
import {ChangeEventInterface} from "@/types/interfaces";
const DEFAULT_TRANSITION = 'slide-left';

Component.registerHooks([
  // "beforeLeave",
  // "enter",
  'afterEnter',
  'beforeRouteUpdate'
]);

@Component({
    components: {
        Login
    }
})
export default class NavBar extends Vue {
    @DocumentsModule.DocumentsGetter private documentTitle;
    @DocumentsModule.DocumentsGetter private documentId;
    @DocumentsModule.DocumentsGetter private documentHideCounter;

    @UsersModule.UsersGetter private user;
    @UsersModule.UsersGetter private participants;
    @UsersModule.UsersGetter private isSignedIn;
    @UsersModule.UsersMutation private logOut;
    @UsersModule.UsersAction private signIn;
    @UsersModule.UsersAction private onAuthStateChanged;
    @UsersModule.UsersAction private updateCurrentUser;

    @ChangeEventsModule.ChangeEventsGetter private changeEvents;

    @RouterModule.RouterGetter private getPath;
    @RouterModule.RouterGetter private currentRoute;
    @RouterModule.RouterGetter private transitionName;
    @RouterModule.RouterMutation private setTransitionName;
    @RouterModule.RouterAction private push;
    @RouterModule.RouterAction private goBack;

    @DisplayModule.DisplayGetter private navBar: NavBarInterface;

    @Watch('$route', { immediate: true, deep: true })
    private onUrlChange() {
       this.drawer.open = false;
        if (!this.isSignedIn && !(this.$route.name === ROUTE_NAME.welcome || this.$route.name === ROUTE_NAME.chooseTopics)) {
            this.google_client_id = process.env.VUE_APP_GOOGLE_CLIENT_ID;
               //@ts-ignore
            google.accounts.id.initialize({
                client_id: this.google_client_id,
                callback: this.handleCredentialResponse,
                context: 'signin'
            });
            //@ts-ignore
            google.accounts.id.prompt();
        }
        document.title = this.documentId;
    }
    private drawer = {
    open: false,
    clipped: true,
    fixed: false,
    permanent: false,
    mini: true,
    };
    private toolbar = {
    fixed: true,
    clippedLeft: false,
    };
    private navItems: any[] = [];

    private dialog = false;

    private google_client_id;

    private dialogAccessDeniedToDocument: boolean = false;

    // private eventsCounter = 0;

    public created() {
        eventBus.$on('signIn', payload => {
          this.dialog = payload;
        });

        // See https://github.com/wonderfloyd/Consenz/tree/master/documentation/RestrictedDocument#restrict_un_allowed_user_from_document_topic
        // Dialog. Not allowed user in this document and should contact the document admin
        eventBus.$on('accessDenied', payload => {
          this.dialogAccessDeniedToDocument = payload;
        });
    }

    get eventsCounter() {
        let events = Object.values(this.changeEvents) as Array<ChangeEventInterface>;
        if (this.documentHideCounter) {
            events = events.filter(event => event.type !== EVENT_TYPE.votedSuggestion);
        }
        if (this.isSignedIn) {
            const user = this.participants[this.user.id];
            if (user.notifications.lastNotificationsTime) {
                return events.filter(event => new Date(event.createdAt).getTime() > new Date(user.notifications.lastNotificationsTime).getTime()).length;
            } else {
                return events.length;
            }
        } else {
            return events.length;
        }
    }

    get isUsersListPage(){
      return this.$route.name === enums.ROUTE_NAME.usersList
    }

    public isDesktop(width) {
        return window.innerWidth > width;
    }

    // changes the drawer to permanent
    public makeDrawerPermanent() {
    this.drawer.permanent = true;
    // set the clipped state of the drawer and toolbar
    this.drawer.clipped = false;
    this.toolbar.clippedLeft = false;
    }

    public onClickNavBar() {
    switch (this.navBar.icon) {
      case NAVBAR_SIDE_ICON.menu:
        this.toggleDrawer();
        break;
      case NAVBAR_SIDE_ICON['arrow_forward']:
        this.setTransitionName('slide-left');
        this.goBack();

        // this.navigate();
        break;
      case NAVBAR_SIDE_ICON.close:
        this.setTransitionName('slide-left');
        this.goBack();
        break;
    }
    }
    public onClickBack() {
      this.$root.$emit('backSuggestion');
    }
    // toggles the drawer type (permanent vs temporary) or shows/hides the drawer
    public toggleDrawer() {
        if (this.drawer.permanent) {
          this.drawer.permanent = !this.drawer.permanent;
          this.drawer.clipped = true;
          this.toolbar.clippedLeft = true;
        } else {
          this.drawer.open = !this.drawer.open;
        }
    }

    private navigate() {
        if (!this.navBar.path || this.navBar.path === this.currentRoute.fullPath) {
          this.push({
            path: this.getPath({ name: ROUTE_NAME.draft, params: {} }),
          });
        } else {
          this.push({ path: this.navBar.path });
        }
    }

    private async logout() {
        if (this.isSignedIn) {
          await firebase.auth().signOut();
          await this.logOut();
          this.toggleDrawer();
          this.drawer.open = false;
        }
    }
    private handleCredentialResponse(response) {
        const credential = firebase.auth.GoogleAuthProvider.credential(response.credential);
        firebase.auth().signInAndRetrieveDataWithCredential(credential)
            .then(async (result) => {
                await this.handleUser(result);
            },
            (error) => {
                this.dialog = false;
                alert(error.message);
            },
        );
    }

    private async handleUser(result) {
        if (result && result.user) {
            this.onAuthStateChanged({ user: result.user, username: result.user.displayName, isNewUser: result.additionalUserInfo.isNewUser });
            this.dialog = false;
        }
    }

    public async goToEventPage() {
        
        if (this.currentRoute.name === 'event') {
            eventBus.$emit("mountVoteFeed");
        } else {
            this.$router.push({name: 'event'});
        }
        if (this.isSignedIn) {
            const notifications = {...this.user.notifications, lastNotificationsTime: new Date()};
            await this.updateCurrentUser({
                updateObject: {notifications}
            });
        }
    }

    private goToWelcome(): void {
      this.$router.push({name: enums.ROUTE_NAME.welcome});
    }
}
